import { Group, Paper, Stack, Text, Title } from "@mantine/core";
import { IconCircleArrowRight, IconCoinEuro } from "@tabler/icons-react";
import { AnchorLink } from "../../../AnchorLink/AnchorLink";
import "../SalesCardLink.scss";

function AusfallSalesCard() {
  return (
    <Paper>
      <Group justify="space-between">
        <Title order={6} size="h4">
          Erlösmonitoring Add-On
        </Title>
        <IconCoinEuro color="var(--mantine-primary-color-filled)" />
      </Group>
      <Stack gap="xs">
        Dieser Reiter ist Teil des Add-Ons Erlösmonitoring. Keines der
        Unternehmen in Ihrem Projekt ist dafür freigeschaltet. Aus diesem Grund
        werden Ihnen keine Werte angezeigt.
        <Text fw={500} fz="h4">
          <AnchorLink
            className="sales-card-link"
            href="https://go.node.energy/opti.node-nachbuchung-add-on-erl%C3%B6smonitoring"
          >
            <IconCircleArrowRight size="1.3em" />
            Bei Interesse an dem Modul können Sie hier Sales kontaktieren.
          </AnchorLink>
        </Text>
      </Stack>
    </Paper>
  );
}

export { AusfallSalesCard };
